var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenericCoverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.5C19.3137 22.5 22 19.8137 22 16.5C22 13.1863 19.3137 10.5 16 10.5C12.6863 10.5 10 13.1863 10 16.5C10 19.8137 12.6863 22.5 16 22.5Z",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 30.5C15.0185 29.8365 13.12 28.673 10.909 27.2745C6.7745 24.736 4.255 20.233 4.255 15.3815C4.25 11.6715 4.25 8 4.25 8C4.25 8 4.727 7.97 5.4175 7.927C8.7105 7.7215 11.84 6.419 14.3065 4.227C15.3745 3.278 16.25 2.5 16.25 2.5C16.25 2.5 17.1255 3.278 18.1935 4.227C20.66 6.419 23.7895 7.7215 27.0825 7.927C27.773 7.97 28.25 8 28.25 8V15.3055C28.25 20.118 25.7715 24.591 21.691 27.142C18.6995 29.003 16.25 30.5 16.25 30.5Z",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericCoverage);
export default __webpack_public_path__ + "static/media/generic-coverage.24dc1896f07ddb8bf9b2fa9b7a11bde1.svg";
export { ForwardRef as ReactComponent };